import { apiClient } from "@/lib/api";
import { PASSWORD_MIN_LENGTH } from "@/lib/passwordPolicy";
import type { LoginRequest, LoginResponse } from "@/types";

/** Mirrors backend ``MIN_PASSWORD_LENGTH`` for staff portal password setup. */
export const STAFF_PASSWORD_MIN_LENGTH = PASSWORD_MIN_LENGTH;

export const authService = {
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    const response = await apiClient.post<LoginResponse>(
      "/auth/login",
      credentials,
      {
        params: { cookie: true },
      },
    );
    return response.data;
  },

  forgotPassword: async (email: string): Promise<{ message: string }> => {
    const response = await apiClient.post<{ message: string }>(
      "/auth/password/forgot",
      { email },
    );
    return response.data;
  },

  validatePasswordSetupToken: async (
    token: string,
  ): Promise<{ valid: boolean }> => {
    const response = await apiClient.get<{ valid: boolean }>(
      "/auth/password/setup/validate",
      { params: { token } },
    );
    return response.data;
  },

  completePasswordSetup: async (body: {
    token: string;
    password: string;
    password_confirm: string;
  }): Promise<void> => {
    await apiClient.post("/auth/password/setup", body);
  },

  impersonate: async (userId: string): Promise<{ access_token: string }> => {
    const response = await apiClient.post<{ access_token: string }>(
      "/auth/impersonate",
      { user_id: userId },
    );
    return response.data;
  },
};
